// src/services/api.js
// Mock API — simulates backend response with component metadata + bounding box coords
// Coordinates are expressed as percentages of the image dimensions (0–100)
// so they remain valid regardless of display size.

const MOCK_COMPONENTS = [
  {
    id: 1,
    name: "Resistor",
    category: "Passive",
    ref: "R1",
    value: "10kΩ",
    tolerance: "±5%",
    package: "0402",
    description: "Pull-up resistor on I2C SDA line",
    bbox: { x: 8, y: 12, w: 14, h: 8 },
    color: "#00d2ff",
  },
  {
    id: 2,
    name: "Capacitor",
    category: "Passive",
    ref: "C1",
    value: "100nF",
    tolerance: "±10%",
    package: "0603",
    description: "Bypass capacitor near MCU VCC pin",
    bbox: { x: 28, y: 10, w: 12, h: 9 },
    color: "#00d2ff",
  },
  {
    id: 3,
    name: "Diode",
    category: "Semiconductor",
    ref: "D1",
    value: "1N4148",
    tolerance: "—",
    package: "SOD-323",
    description: "Flyback protection diode",
    bbox: { x: 50, y: 15, w: 13, h: 7 },
    color: "#a78bfa",
  },
  {
    id: 4,
    name: "Transistor",
    category: "Semiconductor",
    ref: "Q1",
    value: "2N3904",
    tolerance: "—",
    package: "SOT-23",
    description: "NPN switching transistor for LED driver",
    bbox: { x: 70, y: 12, w: 14, h: 10 },
    color: "#a78bfa",
  },
  {
    id: 5,
    name: "Microcontroller",
    category: "IC",
    ref: "U1",
    value: "STM32F103",
    tolerance: "—",
    package: "LQFP-48",
    description: "Main application processor @ 72MHz",
    bbox: { x: 35, y: 35, w: 28, h: 28 },
    color: "#f59e0b",
  },
  {
    id: 6,
    name: "Voltage Regulator",
    category: "Power",
    ref: "U2",
    value: "AMS1117-3.3",
    tolerance: "±2%",
    package: "SOT-223",
    description: "3.3V LDO regulator for digital supply",
    bbox: { x: 10, y: 65, w: 16, h: 12 },
    color: "#34d399",
  },
  {
    id: 7,
    name: "Crystal Oscillator",
    category: "Timing",
    ref: "Y1",
    value: "8 MHz",
    tolerance: "±30ppm",
    package: "HC-49S",
    description: "System clock source for MCU",
    bbox: { x: 68, y: 60, w: 14, h: 10 },
    color: "#f472b6",
  },
  {
    id: 8,
    name: "LED",
    category: "Passive",
    ref: "LED1",
    value: "Green 3.2V",
    tolerance: "—",
    package: "0603",
    description: "Power-on indicator LED",
    bbox: { x: 82, y: 80, w: 10, h: 8 },
    color: "#00d2ff",
  },
];

export const CATEGORIES = ["All", "Passive", "Semiconductor", "IC", "Power", "Timing"];

export const fetchComponents = () =>
  new Promise((resolve) => setTimeout(() => resolve(MOCK_COMPONENTS), 900));
